import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { variation } from 'ember-launch-darkly';
import { HdsCardContainer } from '@hashicorp/design-system-components/components';

/**
 *
 * `PageHvnsCardsFlowDiagram` this renders the HVN Flow Diagram image.
 *
 *
 * ```
 * <Page::Hvns::Cards::FlowDiagram/>
 * ```
 *
 * @class PageHvnsCardsFlowDiagram
 *
 */
export default class PageHvnsCardsFlowDiagram extends Component {
  <template>
    <div class="hvns-cards-hvn-flow-diagram" data-test-hvns-cards-flow-diagram>
      <HdsCardContainer @level="mid" @hasBorder={{true}}>
        <img
          src={{t
            (if
              (variation "hcp-rebrand-milestone-0")
              "components.page.hvns.cards.flow-diagram.src-rebrand"
              "components.page.hvns.cards.flow-diagram.src"
            )
          }}
          alt={{t "components.page.hvns.cards.flow-diagram.alt"}}
        />
      </HdsCardContainer>
    </div>
  </template>
}
